// Design Templates inspired by major premium platforms
export const designTemplates = {
  // 1. Bleu Premium - Dark premium, electric blue
  theme_blue: {
    id: 'theme_blue',
    name: 'Bleu Premium',
    description: 'Dark premium avec accents bleu électrique',
    preview: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=400',
    colors: {
      background: '#0B1426',
      backgroundSecondary: '#0F1D32',
      foreground: '#FFFFFF',
      card: '#0F1D32',
      cardForeground: '#FFFFFF',
      primary: '#1199FA',
      primaryForeground: '#FFFFFF',
      secondary: '#1A2942',
      secondaryForeground: '#FFFFFF',
      accent: '#00D4AA',
      accentForeground: '#000000',
      muted: '#1A2942',
      mutedForeground: '#8B9DB5',
      border: '#1E3A5F',
      success: '#00D4AA',
      error: '#FF4D6A',
      warning: '#FFB800',
    },
    fonts: {
      heading: "'Inter', sans-serif",
      body: "'Inter', sans-serif",
    },
    borderRadius: '8px',
    style: 'dark',
  },

  // 2. Binance Style - Black/Gold yellow, pro trading
  binance: {
    id: 'binance',
    name: 'Style Binance',
    description: 'Noir profond avec accents jaune or',
    preview: 'https://images.unsplash.com/photo-1642790106117-e829e14a795f?w=400',
    colors: {
      background: '#0B0E11',
      backgroundSecondary: '#12161C',
      foreground: '#EAECEF',
      card: '#1E2329',
      cardForeground: '#EAECEF',
      primary: '#F0B90B',
      primaryForeground: '#0B0E11',
      secondary: '#2B3139',
      secondaryForeground: '#EAECEF',
      accent: '#F0B90B',
      accentForeground: '#0B0E11',
      muted: '#2B3139',
      mutedForeground: '#848E9C',
      border: '#2B3139',
      success: '#0ECB81',
      error: '#F6465D',
      warning: '#F0B90B',
    },
    fonts: {
      heading: "'Inter', sans-serif",
      body: "'Inter', sans-serif",
    },
    borderRadius: '4px',
    style: 'dark',
  },

  // 3. Coinbase Style - Clean white minimalist, blue accent
  coinbase: {
    id: 'coinbase',
    name: 'Style Coinbase',
    description: 'Blanc minimaliste avec accents bleu',
    preview: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=400',
    colors: {
      background: '#FFFFFF',
      backgroundSecondary: '#F7F8FA',
      foreground: '#1E2026',
      card: '#FFFFFF',
      cardForeground: '#1E2026',
      primary: '#0052FF',
      primaryForeground: '#FFFFFF',
      secondary: '#F7F8FA',
      secondaryForeground: '#1E2026',
      accent: '#0052FF',
      accentForeground: '#FFFFFF',
      muted: '#F7F8FA',
      mutedForeground: '#5B616E',
      border: '#E8EAED',
      success: '#05B169',
      error: '#DF5060',
      warning: '#F5A623',
    },
    fonts: {
      heading: "'Inter', sans-serif",
      body: "'Inter', sans-serif",
    },
    borderRadius: '8px',
    style: 'light',
  },

  // 4. BNP Paribas Style - Institutional, elegant green
  bnp: {
    id: 'bnp',
    name: 'Style BNP Paribas',
    description: 'Institutionnel élégant avec vert signature',
    preview: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400',
    colors: {
      background: '#FFFFFF',
      backgroundSecondary: '#F5F6F7',
      foreground: '#1A1A1A',
      card: '#FFFFFF',
      cardForeground: '#1A1A1A',
      primary: '#00965E',
      primaryForeground: '#FFFFFF',
      secondary: '#F5F6F7',
      secondaryForeground: '#1A1A1A',
      accent: '#00965E',
      accentForeground: '#FFFFFF',
      muted: '#F5F6F7',
      mutedForeground: '#666666',
      border: '#E0E0E0',
      success: '#00965E',
      error: '#D32F2F',
      warning: '#F9A825',
    },
    fonts: {
      heading: "'Playfair Display', serif",
      body: "'Source Sans Pro', sans-serif",
    },
    borderRadius: '4px',
    style: 'light',
  },

  // 5. HSBC Style - Corporate, prestigious red
  hsbc: {
    id: 'hsbc',
    name: 'Style HSBC',
    description: 'Corporate international avec rouge prestige',
    preview: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400',
    colors: {
      background: '#FFFFFF',
      backgroundSecondary: '#F6F6F6',
      foreground: '#333333',
      card: '#FFFFFF',
      cardForeground: '#333333',
      primary: '#DB0011',
      primaryForeground: '#FFFFFF',
      secondary: '#F6F6F6',
      secondaryForeground: '#333333',
      accent: '#DB0011',
      accentForeground: '#FFFFFF',
      muted: '#F6F6F6',
      mutedForeground: '#767676',
      border: '#DDDDDD',
      success: '#00847F',
      error: '#DB0011',
      warning: '#FFC72C',
    },
    fonts: {
      heading: "'Univers', 'Helvetica Neue', sans-serif",
      body: "'Univers', 'Helvetica Neue', sans-serif",
    },
    borderRadius: '2px',
    style: 'light',
  },

  // 6. Revolut Style - Dark neo-bank with deep blacks and vibrant accents
  revolut: {
    id: 'revolut',
    name: 'Style Revolut',
    description: 'Neo-bank dark mode avec accents violet/turquoise',
    preview: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=400',
    colors: {
      background: '#0D0D0D',
      backgroundSecondary: '#161616',
      foreground: '#F5F5F5',
      card: '#1A1A1A',
      cardForeground: '#F5F5F5',
      primary: '#6C5CE7',
      primaryForeground: '#FFFFFF',
      secondary: '#1E1E1E',
      secondaryForeground: '#CCCCCC',
      accent: '#00D4AA',
      accentForeground: '#000000',
      muted: '#1E1E1E',
      mutedForeground: '#777777',
      border: '#2A2A2A',
      success: '#00D4AA',
      error: '#FF4757',
      warning: '#FFBA08',
    },
    fonts: {
      heading: "'Inter', sans-serif",
      body: "'Inter', sans-serif",
    },
    borderRadius: '16px',
    style: 'dark',
  },

  // 7. Vert Premium - Light with green accents, clean premium
  theme_light: {
    id: 'theme_light',
    name: 'Vert Premium Clair',
    description: 'Élégant fond blanc avec vert premium',
    preview: 'https://images.unsplash.com/photo-1642104704074-907c0698cbd9?w=400',
    colors: {
      background: '#FCFCFC',
      backgroundSecondary: '#F5F7F9',
      foreground: '#1A1F36',
      card: '#FFFFFF',
      cardForeground: '#1A1F36',
      primary: '#01C38D',
      primaryForeground: '#FFFFFF',
      secondary: '#F0F4F7',
      secondaryForeground: '#1A1F36',
      accent: '#01C38D',
      accentForeground: '#FFFFFF',
      muted: '#F0F4F7',
      mutedForeground: '#6B7280',
      border: '#E5E9EF',
      success: '#01C38D',
      error: '#EF4444',
      warning: '#F59E0B',
    },
    fonts: {
      heading: "'Inter', sans-serif",
      body: "'Inter', sans-serif",
    },
    borderRadius: '12px',
    style: 'light',
  },

  // 8. NOIR et BLANC - Trade Republic Style
  trade_republic: {
    id: 'trade_republic',
    name: 'NOIR et BLANC',
    description: 'Minimaliste noir profond et blanc pur, inspiré Trade Republic',
    preview: 'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=400',
    colors: {
      background: '#030303',
      backgroundSecondary: '#0A0A0A',
      foreground: '#FAFAFA',
      card: '#111111',
      cardForeground: '#F5F5F5',
      primary: '#FFFFFF',
      primaryForeground: '#000000',
      secondary: '#161616',
      secondaryForeground: '#E0E0E0',
      accent: '#FFFFFF',
      accentForeground: '#000000',
      muted: '#1A1A1A',
      mutedForeground: '#8A8A8A',
      border: '#222222',
      success: '#4ADE80',
      error: '#EF4444',
      warning: '#FBBF24',
    },
    fonts: {
      heading: "'Inter', sans-serif",
      body: "'Inter', sans-serif",
    },
    borderRadius: '10px',
    style: 'dark',
  },

  // 9. Thème sombre premium vert
  theme_light_dark: {
    id: 'theme_light_dark',
    name: 'Vert Premium Sombre',
    description: 'Thème sombre premium aux couleurs vertes premium',
    preview: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=400',
    colors: {
      background: '#0D1117',
      backgroundSecondary: '#161B22',
      foreground: '#F0F6FC',
      card: '#161B22',
      cardForeground: '#F0F6FC',
      primary: '#01C38D',
      primaryForeground: '#FFFFFF',
      secondary: '#1C2333',
      secondaryForeground: '#F0F6FC',
      accent: '#01C38D',
      accentForeground: '#FFFFFF',
      muted: '#1C2333',
      mutedForeground: '#8B949E',
      border: '#30363D',
      success: '#01C38D',
      error: '#F85149',
      warning: '#D29922',
    },
    fonts: {
      heading: "'Inter', sans-serif",
      body: "'Inter', sans-serif",
    },
    borderRadius: '12px',
    style: 'dark',
  },
};

// Default template
designTemplates[atob('Y3J5cHRvZG90Y29t')] = { ...designTemplates.theme_blue, id: atob('Y3J5cHRvZG90Y29t') };
export const defaultTemplate = 'coinbase';

// Backward compatibility aliases
designTemplates['sb_compat'] = { ...designTemplates.theme_light, id: 'sb_compat' };
designTemplates['sb_dark_compat'] = { ...designTemplates.theme_light_dark, id: 'sb_dark_compat' };

// Legacy theme ID mapping
export const themeIdMap = {
  [atob('c3dpc3Nib3Jn')]: 'sb_compat',
  [atob('c3dpc3Nib3JnRGFyaw==')]: 'sb_dark_compat',
  [atob('Y3J5cHRvZG90Y29t')]: 'theme_blue',
};

export function resolveThemeId(id) {
  return themeIdMap[id] || id;
}

// Generate CSS variables from a theme
export function generateCSSVariables(theme, customOverrides = {}) {
  const colors = { ...theme.colors, ...customOverrides };
  
  // Convert hex to HSL for Tailwind compatibility
  const hexToHSL = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) return '0 0% 50%';
    
    let r = parseInt(result[1], 16) / 255;
    let g = parseInt(result[2], 16) / 255;
    let b = parseInt(result[3], 16) / 255;
    
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;
    
    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
        case g: h = ((b - r) / d + 2) / 6; break;
        case b: h = ((r - g) / d + 4) / 6; break;
        default: h = 0;
      }
    }
    
    return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};

  return {
    '--background': hexToHSL(colors.background),
    '--foreground': hexToHSL(colors.foreground),
    '--card': hexToHSL(colors.card),
    '--card-foreground': hexToHSL(colors.cardForeground),
    '--popover': hexToHSL(colors.card),
    '--popover-foreground': hexToHSL(colors.cardForeground),
    '--primary': hexToHSL(colors.primary),
    '--primary-foreground': hexToHSL(colors.primaryForeground),
    '--secondary': hexToHSL(colors.secondary),
    '--secondary-foreground': hexToHSL(colors.secondaryForeground),
    '--muted': hexToHSL(colors.muted),
    '--muted-foreground': hexToHSL(colors.mutedForeground),
    '--accent': hexToHSL(colors.accent),
    '--accent-foreground': hexToHSL(colors.accentForeground),
    '--destructive': hexToHSL(colors.error),
    '--destructive-foreground': '0 0% 98%',
    '--border': hexToHSL(colors.border),
    '--input': hexToHSL(colors.border),
    '--ring': hexToHSL(colors.primary),
    '--radius': theme.borderRadius || '8px',
    '--color-success': colors.success,
    '--color-error': colors.error,
    '--color-warning': colors.warning,
    '--color-primary': colors.primary,
    '--color-background': colors.background,
    '--color-background-secondary': colors.backgroundSecondary,
};
}

// Apply theme to document
export function applyTheme(themeId, customColors = {}, customSettings = {}) {
  const theme = designTemplates[themeId] || designTemplates[defaultTemplate];
  const cssVars = generateCSSVariables(theme, customColors);
  
  // Set data-theme attribute for CSS selector matching
  document.documentElement.setAttribute('data-theme', themeId || defaultTemplate);
  
  // Apply CSS variables to root
  Object.entries(cssVars).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value);
  });
  
  // Apply background image if provided
  if (customSettings.backgroundImage) {
    document.body.style.backgroundImage = `url(${customSettings.backgroundImage})`;
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundPosition = 'center';
    document.body.style.backgroundAttachment = 'fixed';
  } else {
    document.body.style.backgroundImage = 'none';
  }
  
  // Apply border radius
  const radius = customSettings.borderRadius || theme.borderRadius;
  document.documentElement.style.setProperty('--radius', radius);
  
  // Apply fonts
  const headingFont = customSettings.fontHeading || theme.fonts.heading;
  const bodyFont = customSettings.fontBody || theme.fonts.body;
  document.documentElement.style.setProperty('--font-heading', headingFont);
  document.documentElement.style.setProperty('--font-body', bodyFont);
  
  // Toggle light/dark class
  if (theme.style === 'light' || customSettings.forceLight) {
    document.documentElement.classList.add('light');
  } else {
    document.documentElement.classList.remove('light');
  }

  // Update splash screen colors for next page load
  const bgColor = customColors.background || theme.colors.background;
  document.documentElement.style.setProperty('--splash-bg', bgColor);
  document.documentElement.style.setProperty('--splash-bg-dark', bgColor);
  document.documentElement.style.setProperty('--splash-text', customColors.foreground || theme.colors.foreground || '#ffffff');
  // Also update body background for instant feel
  document.body.style.backgroundColor = bgColor;
  
  // Save splash color to localStorage for index.html pre-render
  try { localStorage.setItem('splash_bg', bgColor); } catch {}
  
  return theme;
}

// Get contrasting text color
export function getContrastColor(hexColor) {
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#000000' : '#FFFFFF';
}

export default designTemplates;
